import { FunctionComponent } from 'react';
import Card from '../../../../../../Card';
import styles from './styles.module.scss';
import { PayInvoiceButton } from '../PayInvoiceButton';
import { DownloadInvoiceButton } from '../DownloadInvoiceButton';
import { AccessCourseButton } from '../AccessCourseButton';
import { AddToCalendarButton } from '../AddToCalendarButton';

type EmailConfirmationCardProps = {
    educatorName: string;
    requestId?: string;
    bookingId?: string;
};

export const EmailConfirmationCard: FunctionComponent<EmailConfirmationCardProps> = ({
    educatorName,
    requestId,
    bookingId,
}) => {
    if (requestId) {
        return (
            <Card>
                <h3 className={styles.heading}>Your request has been sent to {educatorName}</h3>
                <span className={styles.reference}>Request reference: {requestId}</span>
            </Card>
        );
    }

    if (bookingId) {
        return (
            <Card>
                <h3 className={styles.heading}>Check your inbox for a confirmation email</h3>
                <span className={styles.reference}>Booking reference: {bookingId}</span>
                <div className={styles.buttons}>
                    <AccessCourseButton bookingId={bookingId} />
                    <PayInvoiceButton />
                    <DownloadInvoiceButton />
                    <AddToCalendarButton bookingId={bookingId} />
                </div>
            </Card>
        );
    }

    return null;
};
